import { makeStyles, Theme } from "@material-ui/core";

export const useRunsStyles = makeStyles((theme: Theme) => ({
	accordion: {
		minWidth: '100%'
	}
}));
